export const i18n = {
    //导航菜单
    lang: "中",
    coname: "Rank AI",
    company: "安徽兰科智能科技有限公司",
    homePage: "首页",
    products: "产品中心",
    solutions: "解决方案",
    apps: "智能应用",
    news: "最新动态",
    introduction: "公司简介",
    cases: "产品展示",
    ai: "人工智能",
    case: "案例",
    about: "关于兰科",
    //首页
    welcome: "您身边的智能服务专家",
    bannerText: {
        first: "专注智能科技",
        second: "推动智慧生活",
    },
    caseTitle: "行业应用产品",
    caseCards: [{
            img: require("../assets/images/home/yejin.jpg"),
            title: "钢铁冶金",
            text: "钢爪裂纹检测、钢爪形变检测、残极跟踪测温",
            index: 0,
        },
        {
            img: require("../assets/images/home/jiankong.jpg"),
            title: "安防监控",
            text: "烟火识别、入侵检测、仪表度数识别、安全帽检测",
            index: 5,
        },
        {
            img: require("../assets/images/home/lingjian.jpg"),
            title: "加工制造",
            text: "铜管缺陷检测、纱卷识别点数、PVC膜型号识别",
            index: 12,
        },
        {
            img: require("../assets/images/home/yaoyong.jpg"),
            title: "药用包装",
            text: "药用铝管缺陷检测",
            index: 9,
        },
        {
            img: require("../assets/images/home/shiping.jpg"),
            title: "食品检测",
            text: "调料包漏油检测、食品包装批号检测",
            index: 10,
        },
    ],
    more:"查看更多",
    proTitle: "公司优势",
    proCards: [{
            icon: require('../assets/images/home/jiegou.png'),
            title: "结构化设计",
            text: "成熟高效的产品设计结构，节省时间提高效率"
        },
        {
            icon: require('../assets/images/home/dingzhi.png'),
            title: "定制化设计",
            text: "针对不同检测需求，设计专属视觉设备搭配"
        },
        {
            icon: require('../assets/images/home/data.png'),
            title: "大数据分析",
            text: "运用大数据分析研判，为客户提供辅助决策"
        },
        {
            icon: require('../assets/images/home/working.png'),
            title: "即装即用",
            text: "硬件软件配套，安装调试一次完成"
        },
        {
            icon: require('../assets/images/home/gaoxiao.png'),
            title: "科研团队",
            text: "依托科大师资团队，提供最新科研技术"
        },
        {
            icon: require('../assets/images/home/hangye.png'),
            title: "行业经验",
            text: "产品涵盖各广，行业经验丰富"
        },
    ],
    partner: "合作伙伴",
    partners: [{
            icon: require("../assets/images/home/kdgc.jpg"),
            url: "http://www.kdgcsoft.com/",
            name: "科大国创",
        },
        {
            icon: require("../assets/images/home/jcd.png"),
            url: "https://jcdtech.cn/",
            name: "井创数字",
        },
        {
            icon: require("../assets/images/home/hangtian.jpg"),
            url: "https://www.cast.cn//",
            name: "中国空间技术研究院",
        },
        {
            icon: require("../assets/images/home/zkd.jpg"),
            url: "https://www.ustc.edu.cn/",
            name: "中科大",
        },
        {
            icon: require("../assets/images/home/zsy.jpg"),
            url: "http://www.sinopec.com/",
            name: "中石化",
        },
        {
            icon: require("../assets/images/home/sgccbz.jpg"),
            url: "http://www.ah.sgcc.com.cn/",
            name: "国家电网（亳州）",
        },
        {
            icon: require("../assets/images/home/wanji.png"),
            url: "http://www.wanjigroup.com/",
            name: "万基铝业",
        },
        {
            icon: require("../assets/images/home/lckj.jpg"),
            url: "http://www.sinomagtech.com/",
            name: "龙磁科技",
        },
        {
            icon: require("../assets/images/home/sh.png"),
            url: "https://www.shuanghui.net/",
            name: "双汇",
        },
        {
            icon: require("../assets/images/home/qiye.png"),
            url: "",
            name: "中安机械",
        },
    ],
    newsdata: [{
        title: "兰科获得国家高新科技企业称号！",
        text: "恭喜兰科获得国家高新科技企业称号！",
        time: "2022年10月30日",
        img: require('../assets/images/home/gaoxin.jpg')
    }, ],
    //产品中心
    prointro: "兰科智能在各个行业深耕行业需求，将人工智能技术以及视觉图像技术与行业内容相结合，在冶金行业、食品医药业、制造业、安防等主流行业中，研发出多款行业智能化视觉产品。",
    protitle: "行业产品",
    proback: "产品背景",
    profunction: "产品功能",
    proadvance: "产品特点",
    prositmap: "产品组成",
    prostitles: [{
            title: "钢铁冶金",
            items: [{
                    title: "钢爪焊接裂纹检测",
                    index: 0,
                },
                {
                    title: "钢爪形变检测",
                    index: 1,
                },
                {
                    title: "残极跟踪测温",
                    index: 2,
                },
                {
                    title: "电解槽状态巡检",
                    index: 3,
                },
                {
                    title: "电解槽漏液巡检",
                    index: 4
                }
            ]
        },
        {
            title: "安防监控",
            items: [{
                    title: "烟火检测",
                    index: 5,
                },
                {
                    title: "入侵检测",
                    index: 6,
                },
                {
                    title: "设备表盘读数识别",
                    index: 7,
                },
                {
                    title: "安全帽检测",
                    index: 8,
                },
            ]
        },
        {
            title: "药用包装",
            items: [{
                title: "药用铝管检测",
                index: 9,
            }, ]
        },
        {
            title: "食品检测",
            items: [{
                    title: "调料包漏油检测",
                    index: 10,
                },
                {
                    title: "食品包装批号检测",
                    index: 11,
                },
            ]
        },
        {
            title: "加工制造",
            items: [{
                    title: "压缩机铜管缺陷检测",
                    index: 12,
                },
                {
                    title: "纱卷识别点数",
                    index: 13,
                },
                {
                    title: "PVC膜型号识别",
                    index: 14,
                },
                {
                    title: "砂锅缺陷检测",
                    index: 15,
                },
                {
                    title: "单片打胶检测",
                    index: 16,
                },

            ]
        }
    ],
    prosdata: [{
            title: "钢爪焊接裂纹检测系统",
            index: 0,
            text1: "钢爪导杆与钢爪焊接处容易出现裂纹，导致电阻过大而无法使用。人工进行检测容易出现漏检且也不安全。本系统能够代替人工进行检测，减少漏检误检，提高效率。",
            text2: [
                "跟踪并捕捉钢爪焊接区域",
                "精确识别钢爪焊接部位裂纹",
                "显示检出裂纹个数，裂纹长度及宽度",
                "与分拣装置实时通信"
            ],
            text3: [
                "裂纹识别精度高，宽度大于1mm或长度大于20mm的裂纹识别率达99%",
                "识别时间在0 .1 s， 满足实施控制要求 "
            ],
            img: require("../assets/images/products/0.png"),
        },
        {
            title: "钢爪形变检测系统",
            index: 1,
            text1: "钢爪由于高电流和腐蚀作用，使用一段时间后外爪会出现弯曲形变。形变超出一定范围后，与新阳极炭块无法对接，需要矫正。人工检查变形，误差大误检且具有危险性。本系统能够代替人工进行检测，提高精度和准确率。",
            text2: [
                "跟踪并捕捉钢爪主要部件区域",
                "精确识别钢爪形变外爪",
                "动态识别刷新，超出位置红色标出",
                "与分拣装置实时通信"
            ],
            text3: [
                "识别算法耗时0.1s以内%",
                "形变量检测精度高，达到1mm"
            ],
            img: require("../assets/images/products/1.png"),
        },
        {
            title: "残极跟踪测温系统",
            index: 2,
            text1: "残极出电解槽，清理之前需要降温，冷却到150℃以下才能进行清理。目前主要是人工挨件测温，存在极高的安全隐患并且效率低下(需要安排专门的测温人员靠近测温)。本系统替代了测温人员的工作，并且具有极高的效率和准确度。",
            text2: [
                "跟踪识别阳极底座",
                "精确测量阳极底座的最高温度",
                "最高温度超出阈值红色标注",
            ],
            text3: [
                "结果自动实时刷新，无需交互",
                "温度结果精度达到0.1℃"
            ],
            img: require("../assets/images/products/2.png"),
        },
        {
            title: "电解槽状态巡检系统",
            index: 3,
            text1: "电解槽需要定时检查反应池情况，通常把钢条伸进反应池，根据钢条的颜色来判断反应池状态。一般需要两个工人，一人手持钢条，一人测量，效率低下且非常危险。本系统结合巡检机器人，能够代替人工进行巡检，安全高效。",
            text2: [
                "识别反应池编号，自动绑定并实时传输测量结果",
                "机器人机械爪控制钢条伸进反应池，动作稳定",
                "视觉测量钢条颜色，计算反应池状态",
            ],
            text3: [
                "只需单人操作，提高巡检效率%",
                "巡检人员无需接触高温区域，安全性好",
                "机器人自动伸缩测温，效率高",
                "测量算法准确度高，精确到0.1mm",
            ],
            img: require("../assets/images/products/3.png"),
        },
        {
            title: "电解槽漏液巡检系统",
            index: 4,
            text1: "电解铝电解槽在反应过程中可能会发生反应液溢出导致泄漏的情况，造成生产事故。目前检查电解槽主要靠巡检人员进行检查，容易出现漏查。本系统能够提供全天24小时泄漏监控，代替人工巡检。",
            text2: [
                "全天候实时监控电解槽外围状态，检测泄漏情况",
                "监控检测记录存储可查",
                "出现泄漏情况立即进行声光报警",
            ],
            text3: [
                "检测分析效率更高"
            ],
            img: require("../assets/images/products/4.png"),
        },
        {
            title: "烟火检测",
            index: 5,
            text1: "烟火检测是安防监控中最常见的功能之一。",
            text2: [
                "实时识别监控画面中制定区域的烟雾和火焰",
                "显示烟火的定位特征框以及特征置信率",
                "检测到烟火后，启动告警，并传送数据",
            ],
            text3: [
                "动态识别无延迟",
                "识别准确率高（99.8%），误报率低（10%以下）",
                "适应白天和夜间，雨天晴天多种场景",
            ],
            img: require("../assets/images/products/5.png"),
        },
        {
            title: "入侵检测",
            index: 6,
            text1: "入侵检测用于检测指定区域内是否有情况外人员入侵等情况。",
            text2: [
                "对指定区域内进行动态捕捉，检测异常人员和动作，判断是否存在入侵情况",
                "与安全设备联动",
                "结合人脸识别，定位入侵人员",
            ],
            text3: [
                "动态识别无延迟",
                "识别准确率高",
                "对应暗光和白天多种场景",
            ],
            img: require("../assets/images/products/6.png"),
        },
        {
            title: "设备表盘读数识别",
            index: 7,
            text1: "仪表盘度数识别常用于厂区中监控设备实时状态。",
            text2: [
                "自动捕捉监控画面中的设备表盘",
                "识别表盘指针度数",
            ],
            text3: [
                "动态识别无延迟%",
                "识别准确率高",
                "支持多种数值表盘和指针表盘识别，包括温度表、电压表、开关，以及文字框表表盘等",
            ],
            img: require("../assets/images/products/7.png"),
        },
        {
            title: "安全帽检测",
            index: 8,
            text1: "安全帽检测是安全生产监控中非常重要的部分。",
            text2: [
                "实时检测监控画面，检测出指定区域中的人员以及安全帽佩戴情况，包括未带安全帽和未按规定要求佩戴安全帽的",
            ],
            text3: [
                "除了佩戴未佩戴，还能检测各种佩戴不规范等情况",
                "动态识别无延迟",
                "识别准确率高，应对多角度视频分析",
            ],
            img: require("../assets/images/products/8.png"),
        }, {
            title: "药用铝管检测系统",
            index: 9,
            text1: "药用铝管印刷过程中会出现印刷不合格的情况，包括缺字、断笔画、重影、漏墨等。人工检测效率低且易出错。本系统能够精准检测出铝管表面印刷缺陷，代替人工完成检测工作。",
            text2: [
                "获取铝管表面完整印刷图像",
                "检测字符缺失、重影、漏墨、断笔画等印刷缺陷，并发送分拣信号，控制分拣设备进行筛选",
            ],
            text3: [
                "适配各种产线速度",
                "检测识别准确率高，可达95%以上"
            ],
            img: require("../assets/images/products/9.png"),
        }, {
            title: "调料包漏油检测系统",
            index: 10,
            text1: "油料调料包在包装时会出现漏油的情况，在包装时需要将漏油的调料包分拣出来。目前是由人工来进行分拣，效率低下且容易漏检。本系统能够自动化捕捉检测调料包漏油情况，代替人工分拣，提高效率。",
            text2: [
                "自动跟踪捕捉调料包",
                "快速检测调料包包装漏油情况",
                "检测到的结果实时刷新显示",
                "与分拣设备通信，发送分拣信号自动分拣"
            ],
            text3: [
                "检测准确率高，能够检测到的油料尺寸最小达到1mm",
                "每小时可分拣4000包"
            ],
            img: require("../assets/images/products/10.png"),
        },
        {
            title: "食品包装批号检测系统",
            index: 11,
            text1: "食品包装打印批号时出现漏印、错印、位置偏移等情况，属于不合格产品，需要进行分拣处理。目前检查批号很多还是由人工方式进行检查，效率低下且容易检错。本系统能够代替人工进行批号检测，减少漏检误检，提高效率。",
            text2: [
                "自动捕捉食品包装袋，定位批号位置",
                "识别批号并分析，判断是否漏印、错印、位置偏移",
                "与分拣系统通信，实现自动检测分拣",
            ],
            text3: [
                "高效率，每小时可处理4000件",
                "高准确率，准确率达到99%"
            ],
            img: require("../assets/images/products/11.png"),
        },
        {
            title: "压缩机铜管缺陷检测装置",
            index: 12,
            text1: "压缩机铜管加工之后需要检出形变、划伤、尺寸不符等不合格品。人工检测效率低且漏检率高。本系统能够高效完成压缩机铜管缺陷检测工作，代替质检人员。",
            text2: [
                "定制化自主设计的产线设备，全自动化流水线",
                "自动获得铜管外观尺寸等特征，检测管身形变、划伤、墩头变形、末端倒角、夹伤、锯齿伤、尺寸不符等缺陷",
                "检测到不合格，发送信号控制分拣设备分拣",
            ],
            text3: [
                "检测精度高，精度可达0.05mm%",
                "覆盖铜管加工中容易出现的大部分缺陷项",
                "检测效率高，单台设备处理速度能达到3600pcs",
            ],
            img: require("../assets/images/products/12.png"),
        },
        {
            title: "纱卷识别点数系统",
            index: 13,
            text1: "纱卷装箱后需要依次清点数量，然后装车出厂。人工进行清点，效率低、容易出现数错或登记错误情况。本系统安装在装箱产线上，能够自动识别纸箱中的纱卷并清点，代替人工完成点数工作。",
            text2: [
                "接收点数信号，自动识别纱卷并统计总数",
                "根据纱卷大小颜色等信息判断是否混料",
                "统计总数保存历史记录可查",
            ],
            text3: [
                "处理耗时0.4s，准确率可达100%",
                "适配产线系统，融入信息化生产系统"
            ],
            img: require("../assets/images/products/13.png"),
        },
        {
            title: "PVC膜型号识别系统",
            index: 14,
            text1: "PVC膜产线包装前需要按型号分装，打包前需要确定PVC膜的型号。PVC膜型号多且图案颜色相近，难以分辨。打包工人对着标准膜判断，出错率高。本系统能够自动迅速识别PVC膜型号，代替工人判断，提高效率和准确率。",
            text2: [
                "接收产线信号，自动开启识别功能",
                "自动获取PVC膜图像，根据底纹和颜色识别型号",
                "识别到的结果自动显示，方便工人分装",
            ],
            text3: [
                "识别耗时小于0.1s",
                "高准确率，识别准确率可达99.9%"
            ],
            img: require("../assets/images/products/14.png"),
        },
        {
            title: "砂锅缺陷检测系统",
            index: 15,
            text1: "PVC膜产线包装前需要按型号分装，打包前需要确定PVC膜的型号。PVC膜型号多且图案颜色相近，难以分辨。打包工人对着标准膜判断，出错率高。本系统能够自动迅速识别PVC膜型号，代替工人判断，提高效率和准确率。",
            text2: [
                "利用上下机位检测砂锅底面毛孔、变形、炸坯等缺陷",
                "利用水平机位，配合旋转平台连续检测砂锅侧面毛孔、变形、炸坯等缺陷",
                "测量砂锅口径",
                "对接分拣设备，发送分拣信号",
            ],
            text3: [
                "检测准确率高，可达98%左右",
                "全方位无死角"
            ],
            img: require("../assets/images/products/15.png"),
        },
        {
            title: "单片打胶检测系统",
            index: 16,
            text1: "电气元件加工之后需要对铜片引脚中的注胶状态进行检查，没打胶或胶水溢出的都属于不合格。目前打胶主要由人工进行检查分拣，效率较低且易漏检。本系统能够自动进行打胶状态检测，代替人工进行检测。",
            text2: [
                "自动识别铜片引脚位置，定位打胶口区域",
                "检测打胶口状态，判断是否打胶，已打胶后则再判断是否溢胶",
                "连接分拣接口，发送分拣控制信号",
            ],
            text3: [
                "自动捕捉定位自动检测，无需控制信号",
                "检测结果准确率高，准确率可达99%"
            ],
            img: require("../assets/images/products/16.png"),
        }
    ],
    //解决方案
    solintro: "兰科智能通过分析行业中固定场景下的需求，再将不同的行业智能视觉产品进行整合，针对不同行业的场景提供专业的解决方案。能够为行业客户提供更全面的智能化服务，提供生产效率，降低成本的同时提高产品质量。",
    refpro: "涉及产品：",
    soldatas: [{
            img: require("../assets/images/home/yejin.jpg"),
            title: "电解铝厂集成制造智能化解决方案",
            text: "本方案为电解铝厂家提供了一套非常完整的安全生产监测系统，通过一系列针对电解铝生产流程进行质量检测而设计的智能化产品，实现安全生产智能化提升，在提高生产效率的同时，也为工厂提高了生产的安全性。适用于各种规模的电解铝厂，也可为其他金属工厂进行定制话设计。",
            text2: "钢爪裂纹检测系统、钢爪形变检测系统、残极跟踪测温系统、电解槽状态巡检系统、电解槽漏液检测系统",
        },
        {
            img: require("../assets/images/home/jiankong.jpg"),
            title: "工厂变电站智慧安防监控解决方案",
            text: "本方案为各种安全要求高的工厂或变电站提供了一套智能化安防监控方案，包括烟火检测、入侵检测和安全帽检测外，还针对工厂或变电站中需要对设备状态进行监控的需要，提供设备仪表度数识别功能，全面丰富的功能将大大提升厂区的安全性。适用于各种生产厂区或设备车间。",
            text2: "烟火识别、入侵检测、仪表度数识别、安全帽检测",
        },

    ],
    //智能应用
    aiContent: [{
            icon: "iconfont icon-pinglun",
            title: "兰科网评内容智能分析服务平台",
            text: "为提高政府的服务水平，及时掌握民众诉求，政务门户网站往往会提供用户意见征集或评论的功能。这些意见收集功能面向大众，每天会收到大量的评论，这些评论有些是无关痛痒的话题，有些是需要政府关注或需解决的课题，政府需要甄别评论的类型，分类处理。由于政府管理人力有限，单靠人工来进行分类处理，效率比较低下，容易错过需要及时处理的事件，造成政府服务质量下降。针对这一问题，兰科网评内容情感分析系统基于TextCNN的深度学习文本分类技术，快速地将评论按照内容类型进行分类，针对需要及时处理的问题，提供多种告警手段，政务机关通过利用该系统可以及时处理民众反映的问题，增强了政务机关处理事务的能力和效率，对改善民生水平产生积极作用。",
        },
        {
            icon: "iconfont icon-V",
            title: "兰科多轮人机对话服务平台",
            text: "随着社会的不断进步和人工智能的快速发展，服务机器人已经逐步应用于生活中的各种场景中为人们提供服务。目前相关产品多为面向开放域对话或其他特定领域对话的服务机器人，效果不佳且可拓展性差。如何提高服务机器人的服务水平就成了社会关注的内容。为了解决这一问题，兰科多轮人机对话引擎基于机器学习方法，有针对性的配置行业语料库，如银行服务机器人的语料库中提供大量针对银行业务的语料，酒店服务机器人的语料库提供酒店服务的语料等，提高了服务机器人的对话能力和服务质量，对于降低人力资源，提高各行业服务效率等方面，具有很大的意义和价值。",
        },
        {
            icon: "iconfont icon-tuxingtuxiangchuli",
            title: "兰科矿石成分智能识别系统",
            text: "在地质研究中，通过显微镜分析岩石薄片并对其进行分类是一项尤为重要的工作。当前对于碳酸盐岩和砂岩样本薄片图像的分析，传统做法是采用人工方式，专业研究人员在偏光显微镜下观察和拍摄相应的显微图像，通过肉眼来鉴定样本的结构和组分。传统的分析方法，需要专业人员来判读，耗时耗力，同时培养一名专业人员需要大量的资金和时间投入，并且人工鉴定很容易受到主观因素的影响，影响专家对岩石薄片样本的观察鉴定结果。近些年数字图像处理技术和人工智能技术的飞速发展，使用计算机对专业的岩石薄片图像进行识别和分析成为可能。通过计算机系统实现对岩石薄片图像的分析，计算机系统能够快速的完成大量岩石薄片图像的分析，并能检测到许多肉眼无法察觉的细节，可以协助研究人员对大量图像进行初步的分类和分析。并且计算机系统可以形成相对统一的分析标准，且能够快速部署和复制，可以很好的解决该行业专业人士较少、培养时间较长的问题。因此，开发一套岩石薄片图像智能识别系统，具有非常实际的价值",
        },
    ],
    aiServiceContent: [{
            icon: "iconfont icon-chazhaobiaodanliebiao",
            title: "文本智能识别分析",
        },
        {
            icon: "iconfont icon-yuyin",
            title: "语音智能识别分析",
        },
        {
            icon: "iconfont icon-tuxingtuxiangchuli",
            title: "图像智能识别处理",
        },
    ],
    aiServiceText: "兰科智能利用机器学习技术，在智能感知和自然语言方面深耕用户的需求，与中国科学技术大学视觉计算实验室合作，研发了多款人工智能应用产品，包括《兰科网评内容智能分析服务平台》、《兰科多轮人机对话服务平台》、《兰科矿石成分智能分析系统》等产品。兰科智能在人工智能技术方面有着深厚的技术和经验积累，面向各行业提供人工智能应用技术研发服务。",
    aiService: "技术方案",
    //关于
    introductionText1: "安徽兰科智能科技有限公司（简称：兰科智能）是一家致力于人工智能、大数据、云计算、物联网等技术，面向社会各行业提供人工智能能软件产品、解决方案以及技术服务的高新科技公司。公司依托中国科学技术大学，向工业提供基于图像智能分析的缺陷检测技术和设备，拥有一批即精通人工智能技术，又有行业软件开发经验的技术人才。",
    introductionText2: "兰科智能利用机器学习技术，在智能感知和自然语言方面深耕用户的需求，结合多种智能化化设备，面向不同行业开发了一系列机器视觉智能化产品，如《钢爪焊接裂纹检测系统》、《钢爪形变检测系统》、《残极温度检测跟踪系统》、《调料包漏油检测系统》、《食品包装批号检测系统》、《纱卷点数系统》、《PVC膜型号识别系统》、《单片打胶检测系统》、《砂锅缺陷检测系统》、《压缩机铜管检测装置》等等。兰科致力于将最前沿的智能化方法与行业实际的需求相结合，为更多生产安防等行业提供更多智能化实用产品，降低生产成本的同时提高生产效率。",
    clickToOffers: "现在就加入我们",
    contactUs: "联系方式",
    address: "公司地址: ",
    addressText: "安徽省合肥市高新区天元路1号软件园2号楼406室",
    busEmail: "商务邮箱: ",
    busPhone: "商务电话: ",
    busEmailText: "xumingyang@ranktek.cn",
    busPhoneText: "18119675306",
    companyInfo: "认识我们",
    offers: "加入我们",
    //底边栏
    copyright: "Copyright©2021-2023",
    footerText: "安徽兰科智能科技有限公司是一家致力于利用人工智能技术，面向社会各行业提供智能化服务的软件产品、解决方案以及技术服务的科技公司。",
    record: "皖ICP备2020019991号-2",
    record2: "皖公网安备 34019202001631号",
    follow: "关注公众号",

    //其他
    ess: {
        content: "安电是由安徽兰科智能开发的一款提供电力安全知识学习和模拟考试的应用。",
        mock: "模拟考试",
        mockContent: "在线模拟，限时考试。",
        day: "每日一练",
        dayContent: "随时随地学习，轻轻松松答题。",
        more: "更多功能",
        moreContent: "顺序练习、专项练习、收藏集、错题集、排行榜",
        android: "Android版",
        androidContent: "即将上线",
        androidVer: "版本 1.0",
        ios: "iOS版",
        iosContent: "敬请期待",
        iosVer: "版本 1.0",
    },
    app_cas: "网评分析",
    cas: {
        content: "兰科网评内容智能分析服务平台上由安徽兰科智能开发的一套政务舆情评论分析与分类服务平台",
        link: "访问平台",
    },
};